import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../ui/button";
import { Badge } from "../ui/badge";
import { ArrowRight, Briefcase } from "lucide-react";

/**
 * Inter-View Employer Experience — landing hero.
 * Composes existing Shadcn primitives; no new design tokens.
 */
export const EmployerHero = () => (
  <section
    className="pt-16 pb-20 lg:pt-24 lg:pb-24 bg-gradient-to-br from-blue-50 to-white"
    data-testid="employer-hero"
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl">
        <Badge
          className="mb-6 bg-blue-100 text-blue-800 hover:bg-blue-200"
          data-testid="employer-hero-badge"
        >
          <Briefcase className="h-3.5 w-3.5 mr-1.5" />
          For Employers
        </Badge>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
          Meet applicants before
          <br />
          they walk through the door.
        </h1>
        <p className="text-lg lg:text-xl text-gray-600 mb-8 leading-relaxed max-w-2xl">
          Inter-View helps you receive stronger applicant first impressions — short
          video and audio introductions, a complete application package, and a
          printable QR code that connects directly to each candidate&apos;s profile.
        </p>
        <div className="flex flex-col sm:flex-row gap-4">
          <Link to="/employers/intake">
            <Button
              size="lg"
              className="bg-blue-600 hover:bg-blue-700 text-white text-lg px-8 py-3 shadow-lg hover:shadow-xl transition-all"
              data-testid="employer-hero-cta-primary"
            >
              Start with the Employer Intake Package
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
          </Link>
          <a href="#how-it-works">
            <Button
              size="lg"
              variant="outline"
              className="text-blue-700 border-blue-300 hover:bg-blue-50 text-lg px-8 py-3"
              data-testid="employer-hero-cta-secondary"
            >
              See how it works
            </Button>
          </a>
        </div>
      </div>
    </div>
  </section>
);
